import { Medium } from '@energiebespaarders/symbols/helpers';
import {
  ChatAlertAlt,
  ClipboardCheck,
  FileEuro,
  Shield,
  WrenchScrewdriver,
} from '@energiebespaarders/symbols/icons/solid';
import { QuoteInfoAccordion } from '../utils';
import { debWarranty } from './constants';

export const heatingInfoAccordions = (
  needsPtc: boolean,
  needsPrepayment: boolean,
): QuoteInfoAccordion[] => [
  {
    key: 'feasibility',
    title: 'Technische haalbaarheid en volledigheid',
    paragraphs: [
      <p key="heating-feasibility-1">
        Deze offerte is geldig onder voorbehoud van technische haalbaarheid. Dit betekent dat er een
        technische controle nodig is, waarna de nog mutaties kunnen plaatsvinden, afhankelijk van
        eventuele complicaties en/of meerwerk.
      </p>,
      <p key="heating-feasibility-2">Onder onvoorziene werkzaamheden verstaan we onder andere:</p>,
      <ul key="heating-feasibility-3">
        <li>Huidig leidingwerk verroest; advies om direct te vervangen;</li>
        <li>Leveren en aanbrengen van nieuw condensafvoer kanaal.</li>
      </ul>,
      <p key="heating-feasibility-4">Onder meerwerk verstaan we onder andere:</p>,
      <ul key="heating-feasibility-5">
        <li>Een slimme thermostaat in plaats van de standaard geselecteerde thermostaat;</li>
        <li>Het Leveren en aanbrengen van een extra radiator;</li>
      </ul>,
    ],
    icon: ClipboardCheck,
    hide: !needsPtc,
  },
  {
    key: 'warranty',
    title: 'Installatiegarantie en service',
    paragraphs: [
      'Na inbedrijfstelling is er 1 jaar installatiegarantie. Dit omvat het gratis verhelpen van storingen die niet het gevolg zijn van onjuist of onoordeelkundig gebruik, onjuist onderhoud of ander verzuim door de gebruiker. Het normale onderhoud is niet in de prijs inbegrepen. We informeren u graag over een onderhoudscontract.',
      debWarranty,
    ],
    icon: Shield,
  },
  {
    key: 'invoicing',
    title: 'Facturatie',
    paragraphs: [
      ...(needsPrepayment
        ? [
            <p key="heating-invoicing-0">
              <Medium>Aanbetaling:</Medium> 25% van het totale offertebedrag wordt na het accepteren
              van de definitieve offerte {needsPtc ? '(dus na de technische controle) ' : ''}in
              rekening gebracht.
            </p>,
            <p key="heating-invoicing-1">
              <Medium>Facturatie:</Medium> 75% van het totale offertebedrag na oplevering.
            </p>,
          ]
        : [
            <p key="heating-invoicing-1">
              <Medium>Facturatie:</Medium> het totale offertebedrag na oplevering.
            </p>,
          ]),
      <p key="heating-invoicing-2">
        <Medium>Betalingstermijn:</Medium> binnen 7 dagen na factuurdatum.
      </p>,
      <p key="heating-invoicing-3">
        <Medium>Uitvoering:</Medium> in overleg, na ontvangst opdracht. Als u de opdracht wilt
        annuleren, zijn hier mogelijk kosten aan verbonden.
      </p>,
    ],
    icon: FileEuro,
  },

  {
    key: 'activities',
    title: 'Montage en coördinatie',
    paragraphs: [
      <p key="heating-activities-1">
        De werkzaamheden rond het installeren van een nieuwe CV-ketel bestaan in hoofdzaak uit:
      </p>,
      <ul key="heating-activities-2">
        <li>
          Het demonteren en afvoeren van de oude CV-ketel en het expansievat (indien deze aanwezig
          zijn);
        </li>
        <li>Het afknellen van de bestaande gasleiding;</li>
        <li>Het monteren van de nieuwe CV-ketel, expansievat en toebehoren;</li>
        <li>Het aansluiten en/of vervangen van rookgasafvoer, water-, gasleiding en riolering;</li>
        <li>Eventueel het monteren van de nieuwe klokthermostaat in de leefruimte.</li>
      </ul>,
      <p key="heating-activities-3">
        Indien niet anders vermeld, zijn de volgende werkzaamheden{' '}
        <Medium>niet in deze offerte opgenomen</Medium>:
      </p>,
      <ul key="heating-activities-4">
        <li>verhelpen van eventuele gebreken aan de bestaande installatie;</li>
        <li>het maken van een nieuw rookgas- en luchttoevoerkanaal (in de schacht);</li>
        <li>aanvullende kosten die samenhangen met onvoorziene- of meerwerkzaamheden:</li>
      </ul>,
    ],
    icon: WrenchScrewdriver,
  },
  {
    key: 'reminders',
    title: 'Let ook hierop',
    paragraphs: [
      <p key="heating-reminders-1">
        Er zijn een aantal aandachtspuntjes voor u als bewoner om de uitvoer zo soepel mogelijk te
        laten verlopen:
      </p>,
      <ul key="heating-reminders-2">
        <li>Er moet een elektriciteitspunt in de ruimte voor de ketel zijn;</li>
        <li>
          De werkplekken dient geheel vrij te zijn van obstakels voordat de installatiewerkzaamheden
          starten;
        </li>
        <li>De bewoner draagt zorg voor een vrije parkeerplaats bij de woning.</li>
      </ul>,
      <p key="heating-reminders-3">De volgende punten zijn niet in deze prijs opgenomen:</p>,
      <ul key="heating-reminders-4">
        <li>
          werkzaamheden van bouwkundige aard, zoals hak-, breek-, metsel-, schilder-, timmer-,
          sleuf- en graafwerk;
        </li>
        <li>
          het aanbrengen van eventuele ontbrekende vereiste voorzieningen aan de bestaande
          installatie;
        </li>
        <li>verhelpen van eventuele gebreken aan de bestaande installatie;</li>
        <li>
          Aanvullende kosten die samenhangen met onvoorziene- of meerwerkzaamheden:
          <ul>
            <li>eventuele leveringskosten van nieuwe producten;</li>
            <li>voorrijkosten om op een nieuwe dag het resterende werk uit te voeren.</li>
          </ul>
        </li>
        <li>het maken van een nieuw rookgas- en luchttoevoerkanaal (in de schacht);</li>
        <li>
          de eventuele kosten voor het verwijderen, vervoeren, opslaan of vernietigen van
          milieu-onveilige (grond)stoffen zoals asbest (tenzij anders is omschreven);
        </li>
        <li>leveren of monteren van niet met name genoemde materialen of diensten.</li>
      </ul>,
    ],
    icon: ChatAlertAlt,
  },
];
